import { render, staticRenderFns } from "./notification_confirm.vue?vue&type=template&id=60ccae7b&"
import script from "./notification_confirm.vue?vue&type=script&lang=ts&"
export * from "./notification_confirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports